/**
 * 权限路由
 * @type {{mutations: {setListAllPerm(*, *): void}, state: {listAllPerm: []}, getters: {getListAllPerm(*): []}, actions: {}}}
 */
const listAllPerm = {
  state: {
    listAllPerm: [],
    showTaskConsoleDrawer: false,
  },
  mutations: {
    setListAllPerm(state, val) {
      state.listAllPerm = val
    },
    SWITCH_TASK_CONSOLE_DRAWER(state, showable) {
      console.log('jinlai0623')
      state.showTaskConsoleDrawer = showable
    },
  },
  actions: {
    switchTaskConsoleDrawer({ commit, state }, showable) {
      //删除数组存放的路由之后，需要再去刷新路由，这是一个异步的过程，需要有回掉函数，所以使用并返回promise对象，也可以让组件在调用的时候接着使用.then的方法
      console.log('actions0623')
      return new Promise((resolve) => {
        //未来成功后回掉的方法
        commit('SWITCH_TASK_CONSOLE_DRAWER', showable)
        resolve(showable)
      })
    },
  },
  getters: {
    getListAllPerm(state) {
      return state.listAllPerm
    },

    /**
     * 校验用户是否有权利显示
     * @param {String} code 权限对应id
     */
    checkUserPurview: (state) => (code) => {
      let b = false
      // console.log(state.listAllPerm)
      // console.log(code)
      for (let i = 0, len = state.listAllPerm.length; i < len; i++) {
        if (state.listAllPerm[i].code == code) {
          b = true
          break
        }
      }
      return b
    },

    /*  /!**
     * 任务中心是否展示
     * @param {String} code 权限对应id
     *!/
    switchTaskConsoleDrawer: (state) => (showable) => {
      /!*let b = false
      // console.log(state.listAllPerm)
      // console.log(code)
      for (let i = 0, len = state.listAllPerm.length; i < len; i++) {
        if (state.listAllPerm[i].code == code) {
          b = true
          break
        }
      }
      return b*!/

      state.showTaskConsoleDrawer = showable
      return state.showTaskConsoleDrawer
    },*/
  },
}
export default listAllPerm
